<div class="switch">
  <input type="checkbox" id="toggle-switch">
  <label for="toggle-switch"></label>
</div>
